import React from "react"

import getDocumentIcon from "../../../icons/document/functions/get-document-icon"

type Props = {
    note            : any

    isHighlighted   : boolean

    onClickNote     : func
}

export default class FinderNote extends React.Component<Props> {

    click = () => {
        this.onClickNote()
    }

    onClickNote = (e?: React.MouseEvent) => {
        if (e) e.stopPropagation()
        if (this.props.onClickNote) this.props.onClickNote(this.props.note)
    }

    render() {
        const icon = getDocumentIcon(this.props.note.noteTypeId)

        const classes = Classes("search-item note", {
            'is-highlighted': this.props.isHighlighted,
            // selected        : this.props.selected
        })

        return (
            <div className={classes}
                 onClick={this.onClickNote}>
                <div className={Classes("search-item-icon", "note-icon", gd.const.note.icon[icon])}/>
                <div className="search-item-details">
                    <div className="search-item-title">{this.props.note.name}</div>
                </div>
                <div className="cf"/>
            </div>
        )
    }
}